import React, { FunctionComponent } from 'react'
import { useTranslation } from 'react-i18next'

import { Heading } from '../../../../App/Components'
import { AbsenceRequestCard } from '../../../../Profile/Components'
import { IAbsenceRequest } from '../../../AbsenceRequestNew/IAbsenceRequestNew'

import { SectionContainer, TextBlock } from './style'

interface IProps {
  statusTitle: string
  statusArray: IAbsenceRequest[]
}

export const ListSection = ({ statusTitle, statusArray }: IProps) => {
  const { t } = useTranslation()

  return (
    <SectionContainer>
      <Heading level={'sectionTitle'}>{t(statusTitle)}</Heading>
      {statusArray.map(request => (
        <AbsenceRequestCard
          key={request.id}
          absenceRequest={request}
          actionType={'review'}
        />
      ))}
      {statusArray.length === 0 ? (
        <TextBlock>{t('No absence requests found.')}</TextBlock>
      ) : null}
    </SectionContainer>
  )
}
